import { render, staticRenderFns } from "./edit-treatment.vue?vue&type=template&id=1d235d65"
import script from "./edit-treatment.vue?vue&type=script&lang=js"
export * from "./edit-treatment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports